(function () {
  "use strict";

  document.querySelectorAll(".suture-finder").forEach(initSutureFinder);

  function initSutureFinder(root) {
    if (root.dataset.sutureFinderInitialized === "true") return;
    root.dataset.sutureFinderInitialized = "true";

    var state = {
      data: null,
      loaded: false,
      loading: false
    };

    // Lazy-load catalog data only when the finder nears the viewport.
    var loadingEl = root.querySelector("[data-loading]");

    function loadData() {
      if (state.loaded) {
        return Promise.resolve(state.data);
      }

      if (state.loading) {
        return Promise.resolve(null);
      }

      state.loading = true;

      if (loadingEl) {
        loadingEl.hidden = false;
        loadingEl.textContent = "Loading suture catalog...";
      }

      return fetch(root.dataset.jsonUrl)
        .then(function (r) {
          if (!r.ok) {
            throw new Error("Catalog request failed");
          }

          return r.json();
        })
        .then(function (json) {
          state.data = json;
          state.loaded = true;
          state.loading = false;

          if (loadingEl) {
            loadingEl.hidden = true;
          }

          populateFilters(root, json);

          return json;
        })
        .catch(function (err) {
          state.loading = false;

          if (loadingEl) {
            loadingEl.hidden = false;
            loadingEl.textContent =
              "Couldn't load catalog data. Please refresh and try again.";
          }

          console.error("Suture Finder:", err);

          return null;
        });
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadData();
              io.disconnect();
            }
          });
        },
        {
          rootMargin: "200px"
        }
      );

      io.observe(root);
    } else {
      loadData();
    }

    // Tabs
    var tabs = root.querySelectorAll(".suture-finder__tab");
    var panels = root.querySelectorAll(".suture-finder__panel");
    var defaultTab = root.dataset.defaultTab || "search";

    function selectTab(name) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.tab === name;

        tab.setAttribute(
          "aria-selected",
          active ? "true" : "false"
        );

        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.panel !== name;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        selectTab(tab.dataset.tab);
        loadData();
      });
    });

    selectTab(defaultTab);

    // Search by item number or brand.
    var searchInput = root.querySelector(
      '[data-panel="search"] .suture-finder__input'
    );

    var searchResults = root.querySelector(
      '[data-results="search"]'
    );

    var searchDebounce;

    searchInput.addEventListener("input", function () {
      clearTimeout(searchDebounce);

      searchDebounce = setTimeout(function () {
        loadData().then(function (data) {
          if (!data) return;

          runSearch(
            data,
            searchInput.value.trim(),
            searchResults
          );
        });
      }, 150);
    });

    function runSearch(data, query, container) {
      if (!query) {
        container.innerHTML = "";
        return;
      }

      var q = query.toLowerCase();

      // First check for an exact manufacturer or Delasco SKU.
      var exactHits = data.filter(function (row) {
        return (
          (row.sku &&
            row.sku.toLowerCase() === q) ||
          (row.delasco_sku &&
            row.delasco_sku.toLowerCase() === q)
        );
      });

      var directMatches;

      if (exactHits.length) {
        directMatches = exactHits;
      } else {
        // Fall back to a partial search across SKU, brand,
        // trade name, and description.
        directMatches = data.filter(function (row) {
          var haystacks = [
            row.sku,
            row.delasco_sku,
            row.brand,
            row.trade_name,
            row.description
          ]
            .filter(Boolean)
            .map(function (value) {
              return String(value).toLowerCase();
            });

          return haystacks.some(function (value) {
            return value.indexOf(q) !== -1;
          });
        });
      }

      if (!directMatches.length) {
        container.innerHTML =
          '<div class="sf-empty">' +
          "No matches. Try a different item number or brand name." +
          "</div>";

        return;
      }

      // Group matches by cross-reference group.
      var byGroup = {};

      directMatches.forEach(function (row) {
        byGroup[row.xref_group] =
          byGroup[row.xref_group] || [];

        byGroup[row.xref_group].push(row);
      });

      var groupIds = Object.keys(byGroup);

      container.innerHTML = groupIds
        .slice(0, 15)
        .map(function (groupId) {
          var matchedRows = byGroup[groupId];

          var isExact = matchedRows.some(function (row) {
            return (
              (row.sku &&
                row.sku.toLowerCase() === q) ||
              (row.delasco_sku &&
                row.delasco_sku.toLowerCase() === q)
            );
          });

          // Special-order rows surface in search only
          // when the special-order SKU itself was the exact match.
          var eligibleMatched = matchedRows.filter(
            function (row) {
              return (
                row.status !== "special_order" ||
                isExact
              );
            }
          );

          var stockedInGroup = data.filter(
            function (row) {
              return (
                row.xref_group === groupId &&
                row.status === "stocked" &&
                !eligibleMatched.some(function (match) {
                  return match.sku === row.sku;
                })
              );
            }
          );

          var rowsToShow =
            eligibleMatched.concat(stockedInGroup);

          if (!rowsToShow.length) {
            return "";
          }

          return renderCardSet(
            data,
            groupId,
            rowsToShow
          );
        })
        .join("");

      attachCardHandlers(container);
    }

    // Browse by material.
    var materialSelect = root.querySelector(
      "[data-material-select]"
    );

    var browseResults = root.querySelector(
      '[data-results="browse"]'
    );

    materialSelect.addEventListener(
      "change",
      function () {
        loadData().then(function (data) {
          if (!data) return;

          renderBrowse(
            data,
            materialSelect.value,
            browseResults
          );
        });
      }
    );

    function renderBrowse(
      data,
      material,
      container
    ) {
      if (!material) {
        container.innerHTML = "";
        return;
      }

      var groupIds = uniq(
        data
          .filter(function (row) {
            return row.material === material;
          })
          .map(function (row) {
            return row.xref_group;
          })
      );

      if (!groupIds.length) {
        container.innerHTML =
          '<div class="sf-empty">' +
          "No items found for this material." +
          "</div>";

        return;
      }

      container.innerHTML = groupIds
        .map(function (groupId) {
          return renderGroup(
            data,
            groupId,
            {
              allowSpecialOrder: false
            }
          );
        })
        .join("");

      attachCardHandlers(container);
    }

    // Find by specification.
    var attrSelects =
      root.querySelectorAll("[data-attr]");

    var attrResults = root.querySelector(
      '[data-results="attributes"]'
    );

    attrSelects.forEach(function (select) {
      select.addEventListener(
        "change",
        function () {
          loadData().then(function (data) {
            if (!data) return;

            runAttributeFilter(data);
          });
        }
      );
    });

    function runAttributeFilter(data) {
      var filters = {};

      attrSelects.forEach(function (select) {
        if (select.value) {
          filters[select.dataset.attr] =
            select.value;
        }
      });

      if (!Object.keys(filters).length) {
        attrResults.innerHTML = "";
        return;
      }

      var matches = data.filter(
        function (row) {
          if (row.status !== "stocked") {
            return false;
          }

          return Object.keys(filters).every(
            function (key) {
              return row[key] === filters[key];
            }
          );
        }
      );

      if (!matches.length) {
        attrResults.innerHTML =
          '<div class="sf-empty">' +
          "No stocked items match that combination. " +
          "Try removing one or more filters." +
          "</div>";

        return;
      }

      attrResults.innerHTML =
        '<div class="sf-chain">' +
        matches.map(cardHtml).join("") +
        "</div>";

      attachCardHandlers(attrResults);
    }

    // Shared result rendering.
    function renderGroup(
      data,
      groupId,
      opts
    ) {
      opts = opts || {};

      var rows = data.filter(function (row) {
        return row.xref_group === groupId;
      });

      if (!rows.length) {
        return "";
      }

      var visibleRows = rows.filter(
        function (row) {
          return (
            row.status !== "special_order" ||
            opts.allowSpecialOrder
          );
        }
      );

      return renderCardSet(
        data,
        groupId,
        visibleRows
      );
    }

    function renderCardSet(
      data,
      groupId,
      rows
    ) {
      if (!rows.length) {
        return "";
      }

      var spec = rows[0];

      var specLine = [
        spec.material
          ? "<strong>" +
            esc(spec.material) +
            "</strong>"
          : null,

        spec.gauge
          ? "Gauge " + esc(spec.gauge)
          : null,

        spec.needle_code
          ? "Needle " +
            esc(spec.needle_code)
          : null,

        spec.strand_length
          ? esc(spec.strand_length)
          : null,

        spec.color
          ? esc(spec.color)
          : null
      ]
        .filter(Boolean)
        .join(" &nbsp;·&nbsp; ");

      var hasStocked = rows.some(
        function (row) {
          return row.status === "stocked";
        }
      );

      return (
        '<div class="sf-group">' +
          '<div class="sf-group__spec">' +
            specLine +
          "</div>" +

          '<div class="sf-chain">' +
            rows.map(cardHtml).join("") +
          "</div>" +

          (
            hasStocked
              ? ""
              :
                '<div class="sf-card__note" style="margin-top:12px;">' +
                  "We don't currently stock this exact specification. " +
                  '<a class="sf-request-btn" ' +
                    'href="mailto:questions@delasco.com?' +
                    "subject=Suture%20request%20-%20" +
                    encodeURIComponent(groupId) +
                  '">' +
                    "Request this item" +
                  "</a>" +
                "</div>"
          ) +

        "</div>"
      );
    }

    function cardHtml(row) {
      var badgeClass =
        "sf-badge--" + row.status;

      var badgeLabel =
        row.status === "stocked"
          ? "In Stock"
          : row.status === "reference"
            ? "Reference Only"
            : "Special Order";

      var isStocked =
        row.status === "stocked";

      var priceHtml =
        isStocked &&
        row.price != null
          ? '<div class="sf-card__price">$' +
            Number(row.price).toFixed(2) +
            "</div>"
          : "";

      var actionHtml;

      if (
        isStocked &&
        row.shopify_handle
      ) {
        actionHtml =
          '<button ' +
            'type="button" ' +
            'class="sf-add-btn" ' +
            "data-add-to-cart " +
            'data-handle="' +
            esc(row.shopify_handle) +
          '">' +
            "Add to Cart" +
          "</button>";

      } else if (isStocked) {
        actionHtml =
          '<button ' +
            'type="button" ' +
            'class="sf-add-btn" ' +
            "disabled" +
          ">" +
            "Product link pending" +
          "</button>";

      } else if (
        row.status === "special_order"
      ) {
        actionHtml =
          '<a ' +
            'class="sf-request-btn" ' +
            'href="mailto:questions@delasco.com?' +
            "subject=Special%20order%20-%20" +
            encodeURIComponent(row.sku) +
          '">' +
            "Ask about ordering this" +
          "</a>";

      } else {
        actionHtml =
          '<span class="sf-card__note">' +
            "Not sold by Delasco" +
          "</span>";
      }

      // Use the Delasco item number when available.
      // Otherwise use the manufacturer's catalog number.
      var displaySku =
        row.delasco_sku || row.sku;

      var imageHtml = row.image_url
        ? '<img ' +
            'class="sf-card__img" ' +
            'src="' +
            esc(row.image_url) +
            '" ' +
            'alt="" ' +
            'loading="lazy"' +
          ">"
        : '<div ' +
            'class="sf-card__img sf-card__img--placeholder" ' +
            'aria-hidden="true"' +
          "></div>";

      var displayTitle =
        row.trade_name
          ? row.trade_name +
            " · " +
            displaySku
          : displaySku;

      return (
        '<div class="sf-card' +
          (
            isStocked
              ? " sf-card--stocked"
              : ""
          ) +
        '">' +

          imageHtml +

          '<div class="sf-card__brand">' +
            esc(row.brand) +
          "</div>" +

          '<div class="sf-card__sku">' +
            esc(displayTitle) +
          "</div>" +

          '<div class="sf-badge ' +
            badgeClass +
          '">' +
            badgeLabel +
          "</div>" +

          '<div class="sf-card__desc">' +
            esc(row.description || "") +
          "</div>" +

          priceHtml +

          actionHtml +

        "</div>"
      );
    }

    function attachCardHandlers(container) {
      container
        .querySelectorAll(
          "[data-add-to-cart]"
        )
        .forEach(function (btn) {
          btn.addEventListener(
            "click",
            function () {
              addToCart(btn);
            }
          );
        });
    }

    function addToCart(btn) {
      var handle = btn.dataset.handle;

      btn.disabled = true;

      var originalText =
        btn.textContent;

      btn.textContent = "Adding...";

      fetch(
        "/products/" +
          handle +
          ".js"
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              "Product request failed"
            );
          }

          return response.json();
        })
        .then(function (product) {
          var variantId =
            product.variants &&
            product.variants[0] &&
            product.variants[0].id;

          if (!variantId) {
            throw new Error(
              "No variant found"
            );
          }

          return fetch(
            "/cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json"
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            }
          );
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              "Add to cart failed"
            );
          }

          btn.textContent = "Added ✓";

          document.dispatchEvent(
            new CustomEvent(
              "cart:refresh"
            )
          );

          setTimeout(function () {
            btn.textContent =
              originalText;

            btn.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          console.error(
            "Suture Finder add-to-cart:",
            err
          );

          btn.textContent =
            "Couldn't add. Try again";

          btn.disabled = false;
        });
    }

    function populateFilters(
      root,
      data
    ) {
      // Material dropdown.
      var materials = uniq(
        data
          .map(function (row) {
            return row.material;
          })
          .filter(Boolean)
      ).sort();

      materialSelect.innerHTML =
        '<option value="">' +
          "Select a material..." +
        "</option>" +

        materials
          .map(function (material) {
            return (
              '<option value="' +
              esc(material) +
              '">' +
              esc(material) +
              "</option>"
            );
          })
          .join("");

      // Specification dropdowns only use stocked items.
      var stocked = data.filter(
        function (row) {
          return row.status === "stocked";
        }
      );

      attrSelects.forEach(
        function (select) {
          var key =
            select.dataset.attr;

          var values = uniq(
            stocked
              .map(function (row) {
                return row[key];
              })
              .filter(Boolean)
          ).sort();

          select.innerHTML =
            '<option value="">Any</option>' +

            values
              .map(function (value) {
                return (
                  '<option value="' +
                  esc(value) +
                  '">' +
                  esc(value) +
                  "</option>"
                );
              })
              .join("");
        }
      );
    }

    function uniq(arr) {
      return arr.filter(
        function (value, index) {
          return (
            arr.indexOf(value) ===
            index
          );
        }
      );
    }

    function esc(value) {
      return String(
        value == null ? "" : value
      ).replace(
        /[&<>"']/g,
        function (character) {
          return {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          }[character];
        }
      );
    }
  }
})();